import React, { useEffect } from 'react';
import './Team.css';

const team = [
  {
    name: 'Rahul Mehta',
    role: 'Founder & CEO',
    bio: 'Visionary leader with 8+ years in digital marketing. Rahul founded DMS Technologies with a mission to help businesses thrive online.',
    skills: ['Business Strategy', 'PPC Advertising', 'Brand Development', 'Team Leadership'],
    emoji: '👨‍💼',
  },
  {
    name: 'Priya Kapoor',
    role: 'Creative Head',
    bio: 'Award-winning creative director with a passion for storytelling through design.',
    skills: ['Creative Direction', 'Campaign Strategy', 'Content Marketing', 'Brand Identity'],
    emoji: '👩‍🎨',
  },
  {
    name: 'Arjun Sharma',
    role: 'Lead Web Developer',
    bio: 'Full-stack developer specializing in high-performance websites and e-commerce platforms.',
    skills: ['React & Next.js', 'WordPress', 'E-Commerce Dev', 'API Integration'],
    emoji: '👨‍💻',
  },
  {
    name: 'Sneha Patil',
    role: 'Senior Graphic Designer',
    bio: 'Visual storyteller with an eye for detail and a passion for pixel-perfect design.',
    skills: ['Adobe Suite', 'UI/UX Design', 'Social Media Graphics', 'Motion Design'],
    emoji: '👩‍💻',
  },
  {
    name: 'Kiran Desai',
    role: 'Digital Marketing Manager',
    bio: 'Data-driven marketer focused on ROI and measurable growth.',
    skills: ['Google Ads', 'Meta Ads', 'SEO/SEM', 'Analytics'],
    emoji: '📊',
  },
  {
    name: 'Ananya Joshi',
    role: 'Social Media Strategist',
    bio: 'Social media expert who builds communities and drives engagement.',
    skills: ['Content Strategy', 'Community Management', 'Influencer Marketing'],
    emoji: '📱',
  },
];

export default function Team() {
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          }
        });
      },
      { threshold: 0.1 }
    );

    const elements = document.querySelectorAll('.animate-on-scroll');
    elements.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  return (
    <div className="team-page">
      <section className="page-hero">
        <div className="container page-hero-content animate-on-scroll">
          <span className="section-tag">The People Behind DMS</span>
          <h1>Meet Our <span>Team</span></h1>
          <p>
            Passionate professionals combining creativity, strategy, and
            technology to deliver exceptional digital results.
          </p>
        </div>
      </section>

      <section className="team-section">
        <div className="container">
          <div className="section-header animate-on-scroll">
            <span className="section-tag">Our Experts</span>
            <h2 className="section-title">The <span>DMS Dream Team</span></h2>
            <p>Talented individuals united by a common goal — your digital success.</p>
          </div>

          <div className="team-grid">
            {team.map((member, i) => (
              <div
                className="team-card animate-on-scroll"
                key={i}
                style={{ transitionDelay: `${i * 0.1}s` }}
              >
                <div className="tc-avatar">
                  <div className="tc-emoji">{member.emoji}</div>
                </div>
                <div className="tc-info">
                  <div className="tc-role">{member.role}</div>
                  <h3>{member.name}</h3>
                  <p>{member.bio}</p>
                  <div className="tc-skills">
                    {member.skills.map((skill, j) => (
                      <span key={j} className="tc-skill">{skill}</span>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ✅ FIXED CTA SECTION */}
      <section className="join-section">
        <div className="container">
          <div className="join-card animate-on-scroll">
            <h2>Want to Join the <span>DMS Family?</span></h2>
            <p>
              We're always looking for passionate, talented individuals to grow with us.
            </p>
            <a
              href="mailto:info@dmstechnologies.in"
              className="btn-primary"
            >
              Send Your Resume →
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}